<template>
  <div class="document">
    <a-layout>
      <a-layout-sider width="272px" style="background: #F7F8FA;text-align:left;" class="open-sider-wrapper">
        <erp-layout-menu :my-menus="menus" theme="light" mode="inline" />
      </a-layout-sider>
      <a-layout style="padding: 0 24px 24px">
        <a-breadcrumb style="margin: 16px 0;text-align:left;">
          <a-breadcrumb-item v-for="(item, index) in panes" :key="index">{{item.catalogName}}</a-breadcrumb-item>
        </a-breadcrumb>
        <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '100vh', textAlign: 'left' }">
          <div v-if="docContent.documentType === 1 && !loadingFis">
            <div class="doc_title">{{docContent.title}}</div>
            <!-- {{docContent.content}} -->
            <div class="doc_html doc-content" v-loaded="docContent.content" v-viewer.static="{movable: false}"></div>
          </div>
          <div class="loading">
            <a-spin :spinning="loadingFis">
            </a-spin>
          </div>
          <div v-if="docContent.documentType === 2 && !loadingFis">
            <div v-for="(item, index) in docContent.apiInterfaceInfoDtoList" v-show="item.version === versionChange" :key="index">
              <div class="doc_tables doc_title">{{item.interfaceName}}</div>
              <div class="doc_title_option">
                <span class="free_charges" v-show="item.isCharge === 0">免费</span>
                <span class="free_charges" v-show="item.isCharge === 1">收费</span>
                <a-select :value="versionChange" style="width: 120px" @change="handleChange">
                  <a-select-option :value="item.version" :id="item.id" v-for="(item, index) in verionList" :key="index">{{item.version}}</a-select-option>
                </a-select>
              </div>
              <div class="doc_face_desc">{{item.interfaceDesc}}</div>
              <div>
                <div class="doc_tables" >
                  <div class="doc_">请求方法：</div>
                  <div class="fun_">{{item.interfaceMethod}}</div>
                </div>
                <div class="doc_tables" v-for="(val, keys) in item.apiInterfaceParamList" :key="keys">
                  <!-- <div class="doc_">请求参数：Request</div> -->
                  <div class="doc-content" v-loaded="val.paramValue" v-viewer.static="{movable: false}"></div>
                </div>
              </div>
            </div>
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>

import { queryListFilterByToken, queryListFilterNotToken } from '@/api/login'
import ErpLayoutMenu from '@/layouts/ErpLayoutMenu'
// import { openNotificationWithIcon } from '@/utils/util'
import { mapGetters, mapState } from 'vuex'

import Vue from 'vue'
import Video from 'video.js'
import cn from 'video.js/dist/lang/zh-CN.json'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Prism from 'prismjs'
import { renderDocContent, isHtmlContent } from '@/utils/markdown'
Vue.use(Viewer)

/**
 * 文档内容渲染：兼容历史富文本 HTML 与管理端新增的 Markdown 内容
 */
function renderDoc (el, binding, vnode, isUpdate) {
  const vm = vnode.context
  const value = binding.value || ''
  // 历史富文本（tinymce 产物）原样渲染，Markdown 走解析器；空内容按富文本分支处理
  const isMarkdown = !!String(value).trim() && !isHtmlContent(value)
  el.innerHTML = renderDocContent(value)
  // Markdown 走 markdown-body 样式，历史富文本保留 tinymce 内容样式
  el.classList.toggle('markdown-body', isMarkdown)
  el.classList.toggle('mce-content-body', !isMarkdown)
  setTimeout(() => {
    vm.initVideo()
    vm.imgAddListen(el)
    // Markdown 渲染时代码已高亮，仅历史富文本需要手动触发
    if (!isMarkdown) {
      Prism.highlightAll()
    }
    // 内容替换后同步 v-viewer（static 模式不会自动感知新插入的图片）
    if (el.$viewer && typeof el.$viewer.update === 'function') {
      el.$viewer.update()
    }
  })
}

export default {
  name: 'DocumentCenter',
  data () {
    return {
      verionList: [],
      versionChange: '',
      loadingFis: false,
      images: [],
      videos: []
    }
  },
  components: {
    ErpLayoutMenu
  },
  directives: {
    'loaded': {
      bind: function (el, binding, vnode) {
        renderDoc(el, binding, vnode, false)
      },
      update: function (el, binding, vnode) {
        if (binding.value === binding.oldValue) return
        renderDoc(el, binding, vnode, true)
      }
    }
  },
  computed: {
    ...mapGetters(['activeKey', 'menus', 'panes']),
    ...mapState({
      'docContent': function (state) {
        console.log(state)
        this.loadingFis = true
        let _docContent = state.isLogin.docContent
        if (_docContent.documentType === 2) {
          this.verionList = []
          this.versionChange = _docContent.version
          _docContent.apiInterfaceInfoDtoList.map((item, index) => {
            this.verionList.push({ version: item.version, id: index })
          })
        }
        setTimeout(() => {
          this.loadingFis = false
          window.scrollTo(0, 0)
        }, 100)
        return _docContent
      }
    })
  },
  mounted () {
    this.loadingFis = true
    this.$store.commit('SET_MENUS_isLoading', true)
    this.getMenuList()
    // 侧边导航栏固定
    let dom = document.querySelector('.open-sider-wrapper')
    let nextSibling = dom['nextSibling']
    let domTop = dom.offsetTop
    let reg = new RegExp('swiper', 'g')
    function setSiderTop () {
      let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      if (scrollTop > domTop) {
        dom.className += reg.test(dom.className) ? '' : ' swiper'
        if (dom.nextSibling) {
          nextSibling.style.marginLeft = '272px'
        }
      } else {
        dom.className = dom.className.replace(reg, '')
        nextSibling.style.marginLeft = '0px'
      }
    }
    window.addEventListener('scroll', setSiderTop)
    this.$once('hook:beforeDestroy', function () {
      window.removeEventListener('scroll', setSiderTop)
    })
  },
  methods: {
    handleChange (value, event) {
      this.versionChange = value
    },

    getMenuList (api = queryListFilterByToken) {
      api({
        platformCodeBind: 'OPEN_API_PORTAL'
      }).then((res) => {
        if (res.code === '200') {
          if (res.data) {
            this.$store.dispatch('setMenus', res.data)
          }
        } else {
          this.getMenuList(queryListFilterNotToken)
        }
      }).finally(() => {
        this.loadingFis = false
        this.$store.commit('SET_MENUS_isLoading', false)
      })
    },

    imgAddListen (wrap) {
      for (let img of wrap.getElementsByTagName('img')) {
        let fun = () => {
          this.videos.map(item => item.pause())
        }
        img.addEventListener('click', fun)
        this.$once('hook:beforeDestroy', function () {
          img.removeEventListener('click', fun)
        })
      }
    },
    initVideo () {
      let index = 0
      for (let videoItem of document.getElementsByTagName('video')) {
        // 已初始化过的 video 跳过，避免切换文档时重复创建播放器
        if (videoItem.className.indexOf('video-js') !== -1) continue
        videoItem.setAttribute('id', 'video' + index++)
        videoItem.className += ' video-js'
        this.videos.push(Video(videoItem, {
          playbackRates: [0.5, 1, 1.5, 2],
          language: 'zh-CN'
        }))
      }
      Video.addLanguage('zh-CN', cn)
    }
  }
}
</script>
<style lang="less">
.document {
  font-family: Tahoma,Helvetica,"microsoft yahei","Hiragino Sans GB",Simsun,\5b8b\4f53,sans-serif;
  .doc_html {
    margin-top: 16px;
  }
  .free_charges {
    margin-right: 15px;
  }
  .doc_tables {
    margin-bottom: 16px;
    font-weight: 400;
    padding-left: 14px;
    font-family: Tahoma,Helvetica,"microsoft yahei","Hiragino Sans GB",Simsun,\5b8b\4f53,sans-serif;
  }
  .doc_ {
    font-weight: 600;
    // font-family: Tahoma,Helvetica,"microsoft yahei","Hiragino Sans GB",Simsun,\5b8b\4f53,sans-serif;
    // padding-left: 10px;
  }
  .fun_ {
    background: #f3f3f3;
    padding: 0 5px;
    margin: 10px 0 0 0;
    color: #2c3e50;
    font-size: 14px;
    line-height: 24px;
    display: inline-block;
    border: 1px #ddd solid;
    border-radius: 2px;
  }
  .doc_title {
    font-size:18px;
    font-weight:600;
    color: #282828;
    padding-left: 15px;
    border-left: 2px solid #4978D6;
  }
}
.doc_title_option {
  margin-bottom: 10px;
}
.doc_face_desc {
  font-size:14px;
  color: #555555;
  margin-bottom: 12px;
}
.loading {
  position: relative;
  left: 50%;
  top: 50%;
}

.open-sider-wrapper {
  width: 272px;
  overflow-x: hidden;
  overflow-y:auto;
  flex: 0 0 272px;
  max-height: 100vh;
  background: #F7F8FA;
  &::-webkit-scrollbar {
    width: 0;
    height: 0px;
  }
  &.swiper {
    position: fixed;
    top: 0;
    width: 272px;
    bottom: 0;
    left: 0;
    z-index: 1000;
  }
}
</style>
